export default "__VITE_ASSET__P647vTt___"